module.exports = ".grid {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n      grid-template-columns: 1fr;\n  grid-gap: 10px; }\n  .grid div {\n    padding: 20px; }\n  .grid .toolsUsed, .grid .toolsAvailable {\n    padding: 0;\n    margin-bottom: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n  .grid .toolsUsed button, .grid .toolsAvailable button {\n      padding: 5px;\n      background-color: #eee;\n      margin-right: 10px; }\n  .container {\n  margin: 0;\n  padding: 20px;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main